/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=3e9b3b6f&scoped=true"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"
import style0 from "./Messages.vue?vue&type=style&index=0&id=3e9b3b6f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9b3b6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e9b3b6f')) {
      api.createRecord('3e9b3b6f', component.options)
    } else {
      api.reload('3e9b3b6f', component.options)
    }
    module.hot.accept("./Messages.vue?vue&type=template&id=3e9b3b6f&scoped=true", function () {
      api.rerender('3e9b3b6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messages/Messages.vue"
export default component.exports